import React from 'react';

const ErrorText = ({ text }) => {
  return text ? (
    <p className='tw-text-xs tw-text-red-300 tw-mt-1'>{text}</p>
  ) : null;
};

export default ErrorText;
